import { data, user } from 'services';
import { getDuration, getDateTime, getShortRFID } from 'services/types';
import { getAmount } from 'libs/common';
import { ParkingCell, ZonesIcons, MeanStatus } from 'libs/ui';
import { BenefitSetForm, TariffSetForm, StayCloseSetForm } from 'libs/forms';

export const getTableParams = (inList = true, t) => {
  const setRight = user.haveRight('rfid.bulk');
  const setActions =
    inList && setRight
      ? [
          {
            title: t('form.Льгота'),
            key: 'benefit',
            form: BenefitSetForm,
            simple: false,
            method: 'stays.bulk_set_exemption',
            idsParam: 'stay_ids',
            otherParams: { reason: 'exemption_document' },
          },
          {
            title: t('sections.Тариф'),
            key: 'tariff',
            form: TariffSetForm,
            simple: false,
            method: 'stays.bulk_set_tariff',
            idsParam: 'stay_ids',
          },
          {
            title: t('buttons.Закрыть парковку'),
            key: 'closestay',
            form: StayCloseSetForm,
            simple: true,
            method: 'stays.bulk_manual_close',
            idsParam: 'stay_ids',
            isDanger: true,
          },
        ]
      : [];

  // get row class
  const getRowClass = (row) => {
    let out = '';
    row.is_suspicious && (out += ' is_suspicious');
    out += row.is_active ? ' active' : ' archive';
    return out;
  };

  // get fields
  const getFields = () => {
    const fields = [
      {
        name: 'stay_zones',
        title: t('grid.Зона'),
        width: 'auto',
        render: (val) => <ZonesIcons stayZones={val} />,
      },
      {
        name: 'is_active',
        title: t('grid.Статус'),
        width: 'auto',
        render: (val) => data.getDictValue('stays.status', val),
      },
      { name: 'client_name', title: t('form.Клиент') },

      { name: 'vehicle_plate', title: t('sections.ГРЗ'), width: 'auto', sortField: 'vehicle_plate', clip: true },
      {
        name: 'mean_type',
        title: t('dict_filter.Тип СО'),
        width: 'auto',
        render: (val) => data.getDictValue('stays.mean_type', val),
        clip: true,
      },
      {
        name: 'mean_number',
        title: t('grid.Номер СО'),
        width: 'auto',
        render: (val, __other, row) => (row.mean_type === 'rfid' ? getShortRFID(val) : val),
        clip: true,
      },
      { name: 'entry_at', title: t('grid.Начало'), width: 210, sortField: 'entry_at', render: (val) => getDateTime(val) },
      { name: 'leave_at', title: t('grid.Конец'), width: 210, sortField: 'leave_at', render: (val) => getDateTime(val) },
      {
        name: 'duration',
        title: t('grid.Длительность'),
        width: 153,
        sortField: 'duration',
        render: (val) => getDuration(val),
        numeric: true,
        clip: true,
      },
      {
        name: 'tariff_name',
        title: t('form.Тариф'),
        width: 175,
        render: (val, _other, row) => {
          if (!val) {
            return '';
          }
          if (inList) {
            return val;
          }
          const link = '/card/tariff?id=' + row.tariff_id;
          return (
            <a target="_blank" rel="noopener noreferrer" href={link}>
              {val}
            </a>
          );
        },
      },
      {
        name: 'amount',
        title: t('grid.Сумма'),
        width: 100,
        sortField: 'amount',
        render: (val) => getAmount(val),
        numeric: true,
        clip: true,
      },
      {
        name: 'additional_info',
        title: <img src="/images/infoIcon.svg" alt="" title={t('grid.Дополнительная информация')} />,
        width: 'auto',
        render: (_val, _other, val) => <MeanStatus row={val} />,
      },
    ];

    if (window.config.central) {
      fields.unshift({
        name: 'parking_id',
        title: t('grid.Парковка'),
        render: (val) => <ParkingCell parking_id={val} cmp={'span'} />,
        width: 'auto',
      });
    }

    return fields;
  };

  return { getFields, getRowClass, setActions };
};
